{
  "profile": {
    "overline": "YOUR SPACE",
    "title": "My",
    "titleHighlight": "Profile",
    "removePhoto": "Remove photo",
    "displayName": "Display Name",
    "displayNamePlaceholder": "How should we call you?",
    "timezone": "Timezone",
    "selectTimezone": "Select timezone",
    "searchTimezone": "Search timezone...",
    "selectTimezoneTitle": "Select Timezone",
    "profileUpdated": "Profile updated",
    "saveChanges": "SAVE CHANGES",
    "masterConsole": "Master Console",
    "masterConsoleHint": "Manage your teachings and live sessions"
  },
  "account": {
    "title": "ACCOUNT",
    "emailVerified": "Email verified",
    "emailNotVerified": "Email not verified",
    "memberSince": "Member since"
  },
  "preferences": {
    "title": "PRACTICE PREFERENCES",
    "notSet": "Preferences not set yet",
    "setupHome": "Set up on Home page",
    "practices": "Practices",
    "preferredTime": "Preferred Time",
    "goals": "Goals",
    "format": "Format"
  },
  "quickLinks": {
    "favorites": "Favorites",
    "following": "Following",
    "schedule": "Schedule",
    "notifications": "Notifications"
  },
  "master": {
    "overline": "MASTER CONSOLE",
    "title": "Architect the",
    "titleHighlight": "Collective",
    "subtitle": "Manage your profile, practices, and live sessions.",
    "identity": "IDENTITY",
    "displayName": "Display Name",
    "displayNamePlaceholder": "How students see you",
    "biography": "Biography",
    "biographyPlaceholder": "Your spiritual path and philosophy...",
    "saveUpdates": "SAVE UPDATES",
    "viewPublic": "VIEW PUBLIC PORTFOLIO",
    "loading": "Unlocking master portal...",
    "libraryTab": "LIBRARY",
    "manifestoTab": "MANIFESTO",
    "communityTab": "COMMUNITY",
    "knowledgeLibrary": "KNOWLEDGE LIBRARY",
    "practicesTab": "PRACTICES",
    "livesTab": "LIVE SESSIONS",
    "recordingsTab": "RECORDINGS",
    "addPractice": "Add New Practice",
    "addLive": "Add Live Session",
    "emptyLibrary": "Your library is currently empty.",
    "noUpcoming": "No upcoming live sessions scheduled.",
    "goLive": "GO LIVE",
    "noRecordings": "No recordings available yet.",
    "playRecording": "PLAY",
    "manifestoVideo": "MANIFESTO VIDEO",
    "currentVideo": "Current video",
    "addManifesto": "Add Manifesto Video",
    "addManifestoHint": "Introduce yourself to potential students",
    "communityFeed": "COMMUNITY FEED",
    "writePost": "Write New Post",
    "noPosts": "No posts yet. Share your first thought with your community!",
    "nameRequired": "Name is required",
    "savedTitle": "Saved",
    "savedMessage": "Your profile updates are pending review.",
    "manifestoUpdated": "Manifesto video updated successfully.",
    "manifestoTitleRequired": "Please enter a video title.",
    "deletePost": "Delete Post",
    "deletePostConfirm": "Are you sure you want to delete this post?",
    "deletePractice": "Delete Practice",
    "deletePracticeConfirm": "Are you sure you want to delete this practice?",
    "cancelLive": "Cancel Live Session",
    "deleteLive": "Delete Live Session",
    "cancelLiveConfirm": "This will cancel the session and notify all subscribed users. This cannot be undone.",
    "deleteLiveConfirm": "Are you sure you want to delete this live session?",
    "failedLoadProfile": "Failed to load profile",
    "failedLoadContent": "Failed to load content",
    "yourProfile": "Your Profile",
    "coverImage": "Cover Image",
    "quickAddPractice": "Add Practice",
    "quickLiveStream": "Live Session",
    "quickNewCircle": "New Circle",
    "quickHostEvent": "Host Event",
    "quickAddPost": "Add Post",
    "createNewCircle": "Create New Circle",
    "noEventsThisDay": "No events on this day.",
    "addToSchedule": "Add to Schedule",
    "addToSchedulePrompt": "What would you like to create?",
    "event": "Event",
    "deleteEvent": "Delete Event",
    "deleteEventConfirm": "Are you sure you want to delete this event?",
    "archiveUrl": "Archive or Live Session URL (Optional)",
    "rejoin": "REJOIN",
    "liveNow": "LIVE"
  },
  "masterModals": {
    "updatePractice": "Update Practice",
    "newPractice": "New Practice",
    "practiceTitle": "Practice Title",
    "practiceTitlePlaceholder": "e.g. Deep Morning Stillness",
    "videoFile": "Video File",
    "chooseVideo": "Choose video file...",
    "durationMin": "Duration (min)",
    "durationPlaceholder": "20",
    "uploading": "UPLOADING...",
    "saveToLibrary": "SAVE TO LIBRARY",
    "updateLive": "Update Live",
    "scheduleLive": "Schedule Live",
    "sessionTitle": "Session Title",
    "sessionTitlePlaceholder": "e.g. Collective Awakening",
    "sessionDescription": "Event Description",
    "sessionDescriptionPlaceholder": "What is the event about?",
    "date": "Date",
    "time": "Time",
    "timezoneLabel": "Timezone: {{tz}}",
    "datePlaceholder": "YYYY-MM-DD",
    "timePlaceholder": "HH:MM",
    "pastDateError": "Cannot schedule a live session in the past. Please select a future date and time.",
    "fillAllFields": "Please fill in all required fields",
    "invalidDate": "Invalid date or time",
    "coverImage": "Cover Image",
    "uploadCustomCover": "Upload custom image",
    "broadcastEvent": "PUBLISH LIVE SESSION",
    "updateManifesto": "Update Manifesto",
    "addManifestoVideo": "Add Manifesto Video",
    "videoTitle": "Video Title",
    "videoTitlePlaceholder": "e.g. Welcome to my practice",
    "visibleOnProfile": "VISIBLE ON PROFILE",
    "hiddenFromProfile": "HIDDEN FROM PROFILE",
    "saveManifesto": "SAVE MANIFESTO",
    "newPost": "New Post",
    "postLabel": "What's on your mind?",
    "postPlaceholder": "Share your thoughts, insights, or updates with your community...",
    "pinnedToTop": "PINNED TO TOP",
    "pinThisPost": "PIN THIS POST",
    "publishPost": "PUBLISH POST"
  },
  "subscriptions": {
    "overline": "COMMUNITY",
    "title": "The Connected",
    "titleHighlight": "Collective",
    "signInHint": "Sign in to manage your master subscriptions and never miss a live session or a new practice.",
    "loading": "Syncing your circle...",
    "noMasters": "You are not following any masters yet. Discover guided wisdom from our masters.",
    "followingCount": "You are connected with {{count}} master",
    "followingCount_plural": "You are connected with {{count}} masters",
    "explore": "Explore Masters",
    "exploreHint": "Find teachers who resonate with your journey and subscribe to stay updated with their wisdom.",
    "browseMasters": "BROWSE MASTERS",
    "connectedSince": "CONNECTED SINCE {{year}}",
    "notificationsOn": "NOTIFICATIONS ON",
    "enableAlerts": "ENABLE ALERTS"
  },
  "status": {
    "draft": "DRAFT",
    "reviewing": "REVIEWING",
    "livePortfolio": "LIVE PORTFOLIO",
    "hidden": "HIDDEN",
    "live": "LIVE"
  },
  "tabs": {
    "feed": "Feed",
    "practices": "Practices",
    "studio": "Studio",
    "circle": "Circle",
    "about": "About",
    "settings": "Settings",
    "profile": "Profile",
    "favorites": "Favorites",
    "events": "Events",
    "rooms": "My live sessions",
    "media": "Media",
    "aboutMaster": "About master",
    "communityChat": "Master's chats",
    "masterChat": "Master's chats",
    "masterChats": "Master's chats",
    "lightPath": "Path of Light",
    "programs": "Programs",
    "journal": "Journal"
  },
  "quickActions": {
    "label": "Quick actions",
    "liveBadge": "LIVE",
    "live": {
      "title": "Live session",
      "subtitle": "Schedule or go live now"
    },
    "offline": {
      "title": "Offline event",
      "subtitle": "Place, date, number of seats"
    },
    "media": {
      "title": "Upload media",
      "subtitle": "Practice photos and videos"
    },
    "program": {
      "title": "Create a program",
      "subtitle": "A cycle of practices on a schedule"
    }
  },
  "feedSidebar": {
    "upcomingEvent": "Upcoming event",
    "allEvents": "All events",
    "goTo": "Open",
    "allRecordings": "All recordings",
    "noRecordings": "No live session recordings yet.",
    "roomRecording": "Live session recording",
    "aboutMaster": "About the master",
    "more": "Learn more",
    "participants": {
      "one": "{{count}} participant",
      "few": "{{count}} participants",
      "many": "{{count}} participants"
    },
    "yourNextBroadcast": "Your next live session",
    "broadcastStatus": {
      "live": "Live session in progress",
      "due": "Start time has arrived",
      "scheduled": "Scheduled"
    },
    "broadcastCta": {
      "openRoom": "Open the live session",
      "returnToRoom": "Back to the live session",
      "prepare": "Get ready",
      "start": "Start the live session",
      "returnToBroadcast": "Back to the live session"
    },
    "startsIn": "In {{value}}",
    "unitHour": "h",
    "unitMinute": "min",
    "latestRecordings": "Latest recordings"
  },
  "communityChat": {
    "previewEmpty": "No messages yet",
    "subscribeCta": "Subscribe to join the conversation",
    "subscribeButton": "Subscribe"
  },
  "circleTab": {
    "search": "Search",
    "wallOf": "{{name}}'s Wall",
    "join": "JOIN",
    "members": "{{count}} members",
    "online": "{{count}} online",
    "subTabs": {
      "chat": "Chat",
      "media": "Media",
      "links": "Links",
      "events": "Events",
      "pins": "Pins"
    },
    "filters": {
      "all": "All",
      "streams": "Live sessions",
      "online": "Online",
      "recordings": "Recordings"
    },
    "roomsTitle": "LIVE SESSIONS & RECORDINGS",
    "room": "LIVE SESSION",
    "recording": "LIVE SESSION RECORDING",
    "startsIn": "IN {{time}}",
    "noRooms": "No live sessions or recordings yet",
    "emptyChat": "No messages yet. Start a conversation!",
    "joinToChat": "Join Circle to start chatting",
    "sharePrompt": "Share with the community...",
    "noCircles": "No circles joined yet",
    "connecting": "Connecting to chat…",
    "quietBeFirst": "It's quiet here. Be the first to share.",
    "privateCircle": "This chat is private.",
    "loadFailed": "Could not load the chat.",
    "noMedia": "No media yet",
    "joinShort": "Join",
    "noMessages": "No messages yet",
    "joinToWrite": "Join to write"
  },
  "feedFilters": {
    "upcoming": "Upcoming",
    "recordings": "Recordings",
    "saved": "Saved",
    "newPractices": "New practices",
    "all": "All",
    "typeAll": "All types",
    "typeLive": "Live sessions",
    "typeRooms": "Practices",
    "typeOffline": "Offline"
  },
  "studio": {
    "createTitle": "Create",
    "publicationsTitle": "My publications",
    "chips": {
      "all": "All",
      "planned": "Planned",
      "archive": "Archive",
      "myPractices": "My practices",
      "saved": "Saved"
    },
    "create": {
      "quickRoom": "Start now",
      "quickRoomHint": "Enter immediately",
      "livePractice": "Live practice",
      "livePracticeHint": "Announce + calendar",
      "liveSession": "Live session",
      "liveSessionHint": "Stream an event",
      "offlineEvent": "Offline",
      "offlineEventHint": "In-person event",
      "uploadPractice": "Upload practice",
      "uploadPracticeHint": "To library"
    }
  },
  "hero": {
    "subscribe": "Follow",
    "subscribed": "Following",
    "friends": "Friends",
    "message": "Message",
    "unfollow": "Unfollow",
    "mutualHint": "Mutual follow opens the chat",
    "intentionCta": "Add your intention"
  },
  "editProfile": {
    "title": "Edit profile",
    "coverLabel": "COVER",
    "orPickImage": "OR PICK AN IMAGE",
    "noImage": "No image",
    "coversFailed": "The cover gallery didn't load.",
    "coverPickFailed": "Couldn't take this cover. Try again, pick another one or upload your own.",
    "coverPickTimeout": "The cover didn't load: the server didn't respond. Check your connection and try again or pick another one.",
    "coverRetry": "Retry",
    "avatarLabel": "PROFILE PHOTO",
    "uploadPhoto": "Upload photo",
    "uploadCover": "Upload cover",
    "replaceCover": "Replace cover",
    "removeCover": "Remove cover",
    "removeShort": "Remove",
    "nameLabel": "NAME",
    "namePlaceholder": "Your name",
    "surnameLabel": "SURNAME",
    "surnamePlaceholder": "Your surname",
    "intentionLabel": "INTENTION",
    "intentionPlaceholder": "E.g. «I want to meditate daily for 10 minutes over the next 4 months»",
    "bioLabel": "ABOUT YOU",
    "bioPlaceholder": "A few words about yourself. Where you're from, how you live, what matters to you.",
    "manifestoLabel": "MANIFESTO VIDEO",
    "uploadVideo": "Upload video",
    "videoSizeHint": "MP4, up to ~100 MB",
    "coverThumbLabel": "Cover",
    "useCurrentFrame": "Use current frame",
    "replaceVideo": "Replace video",
    "pauseHint": "Pause the video on the right moment and tap «Use current frame».",
    "loadVideoFirst": "Load a video first, then pick a frame for the cover.",
    "uploadingVideo": "Uploading video…",
    "socialsLabel": "CONTACTS & SOCIAL",
    "websiteRow": "Website",
    "cancel": "Cancel",
    "save": "Save"
  },
  "native": {
    "sectionSoon": "The «{{section}}» section is coming soon",
    "notificationsUnread": "Notifications, unread: {{count}}",
    "shareProfile": "{{name}}'s profile on Agapella",
    "youBadge": "THIS IS YOU",
    "becomeMaster": "BECOME A MASTER",
    "applicationPending": "APPLICATION UNDER REVIEW",
    "followersWord_one": "follower",
    "followersWord_other": "followers",
    "followingWord_one": "following",
    "followingWord_other": "following",
    "profileTab": {
      "aboutMe": "About me",
      "description": "Description",
      "notFilled": "not filled in",
      "location": "City / country",
      "notSpecified": "not specified",
      "timezone": "Time zone",
      "bySystem": "system default",
      "lookingFor": "What I'm looking for",
      "notChosenHint": "Nothing chosen — fill it in under «Settings»",
      "interests": "My interests",
      "preferences": "Preferences",
      "eventFormat": "Event format",
      "daytime": "Time of day",
      "timeRange": "Time range",
      "language": "Language",
      "myPath": "My path",
      "withUsSince": "With us since",
      "roomsCreated": "Live sessions created",
      "followers": "Followers",
      "following": "Following",
      "notChosen": "not chosen"
    },
    "editProfile": {
      "nameMin": "Enter a name (at least 2 characters).",
      "saveFailed": "Couldn't save. Please try again.",
      "name": "Name",
      "surname": "Surname",
      "bioPlaceholder": "Tell about yourself and your approach",
      "experiencePlaceholder": "Years of practice, what you do",
      "educationPlaceholder": "Degrees, courses, certificates",
      "uniquenessPlaceholder": "What makes your approach different"
    },
    "basicInfo": {
      "nickname": "Nickname",
      "nicknamePlaceholder": "For example, anna_light",
      "title": "Basic information",
      "bioPlaceholder": "A few words about yourself",
      "locationPlaceholder": "For example: Moscow",
      "timezonePlaceholder": "For example: Europe/Moscow"
    },
    "followersModal": {
      "loadFailed": "Couldn't load the list",
      "unavailable": "The list is temporarily unavailable. Please try later.",
      "noFollowers": "No followers yet.",
      "noFollowing": "Not following anyone yet.",
      "subscribed": "Following",
      "title": "Connections",
      "close": "Close",
      "groupAwaiting": "Waiting for a reply",
      "groupMutual": "Mutual",
      "groupOnlyYou": "Only you follow",
      "captionThey": "follows you",
      "captionYou": "you follow",
      "captionMutual": "you follow each other",
      "masterTag": "master",
      "reply": "Follow back",
      "follow": "Follow",
      "followingNow": "Following",
      "message": "Message {{name}}"
    },
    "userSettings": {
      "tabBasic": "Basic",
      "tabPhoto": "Photo/Cover",
      "tabExtra": "More",
      "savedBody": "Your preferences are updated.",
      "saveFailed": "Couldn't save the changes.",
      "editBasic": "Edit basic information",
      "multiSelectHint": "Multiple choice — pick everything that resonates.",
      "interestsHint": "The more often an interest comes up, the better the recommendations.",
      "preferredDaytime": "Preferred time of day",
      "timeRangeHint": "Ranges within the chosen time of day are available",
      "saveChanges": "SAVE CHANGES",
      "accountHint": "Signing out ends the session on this device. Deleting the account is an action that can only be undone by writing to support."
    },
    "chatTab": {
      "notPublished": "The master's chats open once the profile is published.",
      "discussions": "Discussions",
      "noDiscussions": "No discussions yet.",
      "noChat": "This discussion has no chat yet.",
      "generalChat": "Community chat",
      "eventDiscussion": "Event discussion"
    },
    "mediaTab": {
      "open": "Open",
      "removeFavorite": "Remove from favourites",
      "edit": "Edit",
      "heroSub": "Manage your practices\nand share them with the world",
      "upload": "Upload a new practice",
      "mine": "My media",
      "emptyMine": "No uploaded practices yet",
      "emptyFavorites": "No favourites yet"
    },
    "circleChat": {
      "quiet": "It's quiet here — start the conversation.",
      "noComments": "No comments yet.",
      "placeholder": "Message…"
    },
    "liveSessionsTab": {
      "recordings": "Live session recordings",
      "management": "Management",
      "rooms": "Shared practices"
    },
    "rooms": {
      "scheduled": "Scheduled",
      "finished": "Finished",
      "minutesCount_one": "{{count}} minute",
      "minutesCount_other": "{{count}} minutes",
      "hoursCount_one": "{{count}} hour",
      "hoursCount_other": "{{count}} hours",
      "sessionsWord_one": "session",
      "sessionsWord_other": "sessions",
      "hidden": "Hidden",
      "deleteTitle": "Delete the live session?",
      "deleteBody": "«{{title}}» will be deleted. This cannot be undone.",
      "deleteFailed": "Couldn't delete",
      "tryAgain": "Please try again.",
      "upTo": "up to {{count}}",
      "start": "Start",
      "empty": "No live sessions yet. Create the first one.",
      "more": "{{count}} more",
      "calendar": "Live session calendar",
      "reset": "Reset",
      "noRoomsThisDay": "No live sessions on this day.",
      "activity": "Your activity",
      "totalRooms": "Live sessions in total",
      "totalTime": "Total time",
      "thisWeek": "This week",
      "editTitle": "Edit the live session",
      "titleLabel": "Title",
      "titlePlaceholder": "Live session title",
      "descPlaceholder": "What the live session is about",
      "visibility": "Who can see it"
    },
    "feed": {
      "noPosts": "No posts yet",
      "publish": "Publish",
      "photo": "Photo",
      "video": "Video",
      "signInToReport": "Sign in to send a report.",
      "comments": "Comments",
      "noComments": "No comments yet. Be the first.",
      "commentPlaceholder": "Write a comment…",
      "more": "More",
      "shareTitle": "{{name}} on Agapella",
      "share": "Share",
      "linkCopied": "Link copied",
      "copyLink": "Copy link",
      "notSent": "Not sent",
      "galleryTitle": "Photo library access",
      "galleryBody": "Allow access to your media to attach a file.",
      "photosOrVideo": "A post can carry either photos or a video.",
      "badImage": "Couldn't read this file. JPEG, PNG or WebP will do.",
      "cancelSendingFeed": "Cancel",
      "photoSendingCount": "Sending photos — {{done}} of {{total}}",
      "savingPhoto": "Saving the photo — {{percent}}%",
      "tooManyPhotosTitle": "Too many photos",
      "tooManyPhotosBody": "A post can carry at most {{count}} photos.",
      "badVideo": "Couldn't read this file. Choose another video.",
      "editPost": "Edit post",
      "postTextPlaceholder": "Post text",
      "replacePhoto": "Replace photo",
      "addPhoto": "Add photo",
      "restorePrevious": "Restore previous",
      "uploadingPercent": "Uploading… {{percent}}%",
      "videoWillBeRemoved": "The video will be removed",
      "undo": "Undo",
      "addVideo": "Add video",
      "uploading": "Uploading",
      "attachPhoto": "Attach a photo",
      "attachVideo": "Attach a video",
      "edit": "Edit",
      "delete": "Delete"
    },
    "post": {
      "failTitle": "Didn't work",
      "editorOpenFailed": "Couldn't open the editor. Please try later.",
      "eventOpenFailed": "Couldn't open the event. Please try later.",
      "tryLater": "Please try again a little later.",
      "linkedPractices": "the practice library",
      "linkedEvents": "Events",
      "pinned": "· Pinned",
      "menuA11y": "Post menu",
      "onlineSessionAnnouncement": "Online session announcement",
      "eventAnnouncement": "Event announcement",
      "sessionEnded": "The live session has ended",
      "sessionAnnouncement": "Live session announcement",
      "goToSession": "Go to the session",
      "unpin": "Unpin",
      "pin": "Pin",
      "deleteTitle": "Delete the post?",
      "deleteEverywhereHint": "«Everywhere» also removes the entry from {{place}} — not only from the feed. This cannot be undone.",
      "deleteFeedOnly": "Feed only",
      "deleteEverywhere": "Delete everywhere (incl. {{place}})",
      "deleteMessage": "This cannot be undone."
    },
    "userFeed": {
      "empty": "Your posts and what the masters you follow share will appear here.",
      "showMore": "Show more",
      "deleteBody": "It will disappear from your feed and your profile.",
      "profileA11y": "Profile: {{name}}",
      "openPost": "Open the post",
      "captionRequired": "Add a few words — a post without text won't be saved.",
      "photoSending": "Sending the photo — {{percent}}%",
      "photoChecking": "Checking the post",
      "cancelSending": "Cancel",
      "photoOrVideo": "A post can carry either a photo or a video.",
      "galleryPhoto": "Allow access to your media to attach a photo.",
      "galleryVideo": "Allow access to your media to attach a video.",
      "sourceMaster": "Master",
      "sourceOfficial": "Agapella",
      "sourceCommunity": "Community",
      "audienceLabel": "Audience",
      "audiencePublic": "For everyone",
      "postLockedTitle": "This post is for the master's subscribers",
      "postLockedBody": "Subscribe to {{name}} to read it",
      "postLockedMaster": "the master",
      "postLockedCta": "Subscribe to the master",
      "postLockedSignIn": "Sign in to subscribe to the master and read the post.",
      "postGone": "This post is unavailable: it was deleted or hidden.",
      "postLoadFailed": "Couldn't open the post.",
      "audienceSubscribers": "For subscribers",
      "photoLimit": "A post can hold at most {{count}} photos.",
      "reactionA11y": "Reaction {{emoji}}, {{count}} so far",
      "commentsCount": "Comments: {{count}}",
      "commentsEmptyAction": "Comment",
      "commentsEmpty": "No one has written yet. Be the first.",
      "commentPlaceholder": "Write a comment",
      "commentSend": "Send comment"
    },
    "guest": {
      "blockConfirm": "Block {{name}}? You will no longer receive messages from this person.",
      "youBlockedName": "You have blocked {{name}}",
      "blockedBody": "This person's posts and messages are no longer shown to you, and they cannot write to you. We passed the report to moderation and will review it within 24 hours.",
      "aboutUser": "About",
      "masterNoBio": "The master hasn't added a description yet.",
      "userNoBio": "This person hasn't added a description yet.",
      "signInToFollow": "Sign in to follow",
      "signInForNotifications": "Sign in to turn on notifications",
      "directionA11y": "Practices in {{direction}}",
      "directionHint": "Opens the practice library for this direction",
      "follow": "Follow",
      "following": "Following",
      "unfollow": "Unfollow",
      "write": "Write",
      "writeMessage": "Write a message",
      "shareProfileA11y": "Share the profile",
      "masterNotifications": "Master notifications",
      "profileNotFound": "Profile not found",
      "profileLoadFailed": "Couldn't open the profile",
      "profileNotFoundHint": "The page may have been removed or the link is out of date.",
      "profileLoadFailedHint": "Check your connection and try again.",
      "user": "User",
      "profileHidden": "Profile hidden",
      "profileHiddenBody": "This person has limited access to their profile.",
      "browseMasters": "Browse masters",
      "feedLoadFailed": "Couldn't load posts.",
      "masterPractices": "{{name}}'s practices",
      "chatsLoadFailed": "Couldn't load chats.",
      "chatsSubscribeHint": "Once you subscribe, the master's discussions and the message field will open."
    },
    "lightPath": {
      "flame": "Flame of Love",
      "soulLight": "Soul Light",
      "level": "Level",
      "cardTitle": "{{name}}'s Path of Light",
      "cardLoadingA11y": "{{title}}. Loading.",
      "cardA11y": "{{title}}. Flame of Love: {{streak}}. Soul Light: {{xp}}. Level: {{level}}.",
      "streakDays_one": "{{count}} day in a row",
      "streakDays_other": "{{count}} days in a row"
    }
  },
  "journal": {
    "title": "My entries",
    "subtitle": "Reflections after practices. Only you can see them.",
    "loadFailedTitle": "Couldn't load",
    "loadFailedText": "Your entries are safe — the request didn't go through. Try again.",
    "retry": "Try again",
    "emptyTitle": "Your entries will appear here",
    "emptyText": "After a practice, Agapella will offer you a moment to pause and write down how it went. Your entries will appear here — you can reread, edit or delete them.",
    "afterPractice": "After a practice",
    "afterPracticeNamed": "After the practice “{{title}}”",
    "afterLiveNamed": "After the live session “{{title}}”",
    "privateToMe": "Only me",
    "aiMayRead": "Agapella can read",
    "visibilityLabel": "Who can read it",
    "visibilityHint": "Agapella can't see a private entry at all.",
    "visibilityFailed": "Couldn't change it. The entry stays as it was.",
    "freeForm": "Free note",
    "otherAnswer": "Answer",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "saveFailed": "Couldn't save. Your text is still here — try again.",
    "emptyEdit": "There's nothing left in this entry. If you don't need it anymore, you can delete it.",
    "deleteTitle": "Delete this entry?",
    "deleteText": "You won't be able to restore it.",
    "deleteConfirm": "Delete",
    "deleteFailed": "Couldn't delete. Try again.",
    "openA11y": "Open the entry from {{date}}",
    "reflection": {
      "title": "Reflection",
      "hint": "You don't need to answer every question — only the ones you feel like answering.",
      "save": "Save",
      "saveFailed": "Couldn't save. Your text is still here — try again.",
      "close": "Close",
      "savedTitle": "Entry saved",
      "savedText": "You can reread it, edit it or hide it from Agapella in your journal — it lives in your profile.",
      "openJournal": "My entries",
      "done": "Done",
      "offerButton": "Write a few lines"
    },
    "privacy": {
      "title": "Reflection",
      "intro": "After a practice you can pause for a moment and write down how it went. A few guiding questions — or a free-form note if you don't feel like answering them.",
      "readers": "Only you can see your entries. Separately, you decide whether Agapella may read them: if yes, she will draw on them when suggesting practices and continuing your conversation. {{privacyHint}}",
      "note": "Your choice will be saved, and we won't ask again with every entry. You can change it in settings, and hide a single entry from Agapella right inside it.",
      "aiMayRead": "Agapella can read",
      "privateToMe": "Only me"
    }
  }
}
